import {
  HttpClient, HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { apiConfiguration } from '../../../../configurations/api-configuration';
import { AccessService } from '../../../application/services/AccessService';
import { HttpResponse } from '../../../application/types/HttpResponse';
import { DashboardUser } from '../../types/Client';

@Injectable()
export class UserDirectoryApiService {
  private readonly usersBaseUrl = `${apiConfiguration.baseApiUrl}/users`;
  private readonly usersUrl = `${this.usersBaseUrl}/directory`;

  public constructor(
    private http: HttpClient,
    private accessService: AccessService,
  ) { }

  public async getUsers(): Promise<HttpResponse<DashboardUser[]>> {
    return lastValueFrom(this.http.get<HttpResponse<DashboardUser[]>>(this.usersUrl, { headers: this.getHeaders() }));
  }

  public async getCurrentUser(): Promise<HttpResponse<DashboardUser>> {
    return lastValueFrom(this.http.get<HttpResponse<DashboardUser>>(`${this.usersBaseUrl}/me`, { headers: this.getHeaders() }));
  }

  private getHeaders(): HttpHeaders {
    const token = this.accessService.getToken();
    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
  }
}
